export { translations } from './translations';
export type { TranslationKey } from './translations';
